<template>
  <div id="D3chart">
    <device-information :dialog.sync="dialog" :device="device"/>
  </div>

</template>

<script>
  import informationIcon from '../../../assets/icons/information.png';
  import DeviceInformation from './DeviceInformation.vue';
  import { STATES } from '../../../constants/constants';

  export default {
    props: ['device', 'deviceId'],
    components: {
      'device-information': DeviceInformation
    },
    data () {
      return {
        moreInfo: {'rightMargin': 55, 'bottomMargin': 20},
        svg: null,
        lineLayer: null,
        circleLayer: null,
        arcCount: 0,
        spotCount: 0,
        defaultBorderColor: '',
        defaultBorderStrokeWidth: 8,
        dialog: false
      };
    },
    watch: {
      device () {
        this.mounted();
      }
    },
    mounted () {
      this.mounted();
    },
    computed: {
      radius () {
        if (this.device.zoom === 16) {
          return this.device.length * 160 / 308;
        } else if (this.device.zoom === 15) {
          return this.device.length * 160 / 592;
        } else if (this.device.zoom === 14) {
          return this.device.length * 160 / 1145;
        }
      },
      lot () {
        if (!this.device.Crops.length) {
          return 'Lote 1';
        }
        return this.device.Crops[0].name;
      },
      start () {
        return {
          'angle': this.device.Event.angle,
          'lapNumber': 0,
          'lapPercentage': 0
        };
      },
      staticMap () {
        if (!this.device.Location) {
          return;
        }
        let urlStaticMap;
        urlStaticMap = `https://maps.googleapis.com/maps/api/staticmap?center=${this.device.Location.latitude},${this.device.Location.longitude}&zoom=${this.device.zoom}&size=${this.mapWidth}x${parseInt(this.mapHeight + 70)}&maptype=satellite&key=${process.env.VUE_APP_STATIC_MAP_API_KEY}`;
        return urlStaticMap;
      },
      width () {
        return screen.width;
      },
      height () {
        return screen.height;
      },
      bottomInfo () {
        let shortName;
        if (this.device.Organization.id !== this.$ponceConfig.organizationDemoId) {
          shortName = `${this.device.Organization.name} - ${this.device.name}`;
        } else {
          shortName = this.device.name;
        };
        return {
          'header': shortName,
          'sub-header': this.device.Crops.length ? this.device.Crops[0].name : 'device test',
          'leftMargin': 20,
          'bottomMargin': 20
        };
      },
      screenRatio () {
        return (screen.width / screen.height);
      },
      mapHeight () {
        let _height = (640 - 70);
        if (this.screenRatio >= 1) { // horizontal
          _height = this.height * 1 < _height ? this.height * 1 : _height;
        } else { // vertical
          _height = this.height * 0.5 < _height ? this.height * 0.5 : _height;
        }
        return _height;
      },
      mapWidth () {
        let _width = 640;
        if (this.width < _width) {
          _width = this.width;
        }
        return _width;
      },
      mapMarginBottom () {
        return 35;
      },
      circleOffset () {
        return 35;
      }
    },
    methods: {
      mounted: function () {
        if (!this.device.Location) {
          return;
        }
        if (document.getElementById('D3chart').firstChild) {
          document.getElementById('D3chart').firstChild.remove();
        }
        this.drawChart('#000', 3);
        this.draw('#D3chart', this.staticMap);
        this.addBorder('#FFF', null, 0, 360); // contorno del lote
        this.setBottomInfo(this.bottomInfo.header, this.bottomInfo['sub-header']);

        if (!this.device.Event) {
          return;
        }
        if ([STATES.IRRIGATING, STATES.MOVING, STATES.FAILURE].includes(this.device.Event.State.value)) { // falla bomba nada mas.. cambiar
          if (this.device.Event.label === 'right') {
            this.addBorder(this.device.Event['border-color'], 8, this.device.prevEvent.angle > this.device.Event.angle ? this.device.prevEvent.angle - 360 : this.device.prevEvent.angle, this.device.Event.angle);
          } else {
            this.addBorder(this.device.Event['border-color'], 8, this.device.Event.angle > this.device.prevEvent.angle ? this.device.Event.angle - 360 : this.device.Event.angle, this.device.prevEvent.angle);
          }
        } else if (this.device.prevEvent) {
          if (this.device.Event.State.value === STATES.FAILURE && this.device.prevEvent.State.value === STATES.FAILURE) {
            this.startSpot(this.device.prevEvent.angle, '#ffffff');
            if (this.device.prevEvent.label === 'right') {
              this.addBorder(this.device.prevEvent['border-color'], 8, this.device.prevEvent.angle > this.device.prevEvent.angle ? this.device.prevEvent.angle - 360 : this.device.prevEvent.angle, this.device.prevEvent.angle);
            } else {
              this.addBorder(this.device.prevEvent['border-color'], 8, this.device.prevEvent.angle > this.device.prevEvent.angle ? this.device.prevEvent.angle - 360 : this.device.prevEvent.angle, this.device.prevEvent.angle);
            }
          }
        }
        if (this.device.Event.State.value === STATES.OFF) {
          this.addSpot(this.device.Event.angle, '#ffffff', 'pause', 'inside');
        } else {
          this.startSpot(this.device.prevEvent.angle, '#ffffff');
          const direction = this.device.Event.direction === 'F' ? 'right' : 'left';
          this.addSpot(this.device.Event.angle, '#ffffff', direction, 'inside');
        }
        this.line(this.device.Event.angle, '#ffffff');
      },
      drawChart: function (defaultBorderColor, defaultBorderStrokeWidth) {
        this.defaultBorderColor = defaultBorderColor;
        this.defaultBorderStrokeWidth = defaultBorderStrokeWidth;
      },
      draw: function (htmlelement, image) {
        this.svg = window.d3.select(htmlelement)
          .append('svg')
          .attr('width', this.mapWidth)
          .attr('height', this.mapHeight)
          .attr('style', 'margin: 0 auto; display: block;')
          .append('g')
          .attr('transform', 'translate(' + (parseInt(this.mapWidth) / 2) + ',' + parseInt(this.mapHeight) * 0.5 + ')');
        this.svg.append('g')
          .attr('transform', 'translate(' + this.mapWidth * -0.5 + ',' + (parseInt(this.mapHeight * 0.5) * -1 - this.mapMarginBottom * 2) + ')')
          .append('image')
          .attr('class', 'image-icon')
          .attr('x', 0)
          .attr('y', 0)
          .attr('width', '100%')
          .attr('height', this.mapHeight + 70)
          .style('height', 'auto')
          .attr('xlink:href', image);

        var svgDefs = this.svg.append('defs');
        var mainGradient = svgDefs.append('linearGradient')
          .attr('id', 'mainGradient')
          .attr('x1', '0%')
          .attr('x2', '0%')
          .attr('y1', '70%')
          .attr('y2', '0%');

        mainGradient.append('stop')
          .attr('class', 'stop-left-gradient')
          .attr('offset', '0');
        mainGradient.append('stop')
          .attr('class', 'stop-right-gradient')
          .attr('offset', '1');
        this.svg.append('rect')
          .classed('fill-gradient', true)
          .attr('x', parseInt(this.mapWidth / -2))
          .attr('y', parseInt(this.mapHeight * 0.3) - 16)
          .attr('width', '100%')
          .attr('height', parseInt(this.mapHeight / 4));

        this.lineLayer = this.svg.append('g');
        this.circleLayer = this.svg.append('g')
          .attr('transform', 'translate(0,' + parseInt(this.circleOffset) * -1 + ')');
      },
      addBorder: function (color, strokeWidth, startAngle, endAngle) {
        var arcID = 'arc-' + this.arcCount;
        var arc = window.d3.arc()
          .innerRadius(this.radius)
          .outerRadius(this.radius)
          .startAngle(this.countPIValue(startAngle))
          .endAngle(this.countPIValue(endAngle));

        this.lineLayer.append('path')
          .attr('transform', 'translate(0,' + parseInt(this.circleOffset) * -1 + ')')
          .style('stroke', color)
          .style('stroke-width', strokeWidth)
          .attr('stroke-dasharray', strokeWidth ? ('0, 0') : ('2,6'))
          .attr('stroke-linecap', strokeWidth ? 'butt' : 'round')
          .attr('id', arcID)
          .attr('d', arc());

        this.arcCount++;
        return arcID;
      },
      startSpot: function (angle, borderColor) {
        this.circleLayer.append('circle')
          .attr('cx', Math.cos(this.countPIValue(270)) * this.radius)
          .attr('cy', Math.sin(this.countPIValue(270)) * this.radius)
          .attr('r', 5)
          .attr('stroke', borderColor)
          .style('stroke-width', 3)
          .attr('transform', 'rotate(' + angle + ')')
          .style('fill', 'white');
        if (this.start.lapNumber > 0) {
          this.circleLayer.append('g')
            .attr('x', Math.cos(this.countPIValue(270)) * this.radius - 5)
            .attr('y', Math.sin(this.countPIValue(270)) * this.radius - 15)
            .attr('transform', 'rotate(' + angle + ') translate(' + (Math.cos(this.countPIValue(270)) * (this.radius + 5)) + ' ' + (Math.sin(this.countPIValue(270)) * (this.radius + 18)) + ')')
            .append('text')
            .attr('transform', 'rotate(-' + angle + ')')
            .text('+' + this.start.lapNumber)
            .attr('stroke', this.device.Event['border-color'])
            .style('fill', this.device.Event['border-color']);
        }
      },
      addSpot: function (angle, borderColor, text, textPosition, circleRadius = 10) {
        var spotID = 'spot-' + this.spotCount;
        this.circleLayer.append('circle')
          .attr('cx', Math.cos(this.countPIValue(270)) * this.radius)
          .attr('cy', Math.sin(this.countPIValue(270)) * this.radius)
          .attr('r', circleRadius)
          .attr('class', spotID)
          .attr('stroke', borderColor)
          .style('stroke-width', 3)
          .attr('transform', 'rotate(' + angle + ')')
          .style('fill', this.getIcon(text, borderColor) ? 'url(#spoticon' + angle + ')' : borderColor);

        if (this.getIcon(text)) {
          this.svg.append('svg:pattern')
            .attr('id', 'spoticon' + angle)
            .attr('width', '100%')
            .attr('height', '100%')
            .attr('patternUnits', 'objectBoundingBox')
            .append('svg:image')
            .attr('class', 'image-icon')
            .attr('xlink:href', this.getIcon(text, borderColor))
            .attr('width', 20)
            .attr('height', 20)
            .attr('x', 0)
            .attr('y', 0);
        } else {
          this.svg.append('text')
            .attr('x', Math.cos(this.countPIValue(270)) * this.mapHeight + this.getTextPosition(textPosition).x)
            .attr('y', Math.sin(this.countPIValue(270)) * this.mapHeight + this.getTextPosition(textPosition).y)
            .text(text)
            .attr('font-family', 'sans-serif')
            .attr('font-size', '10px')
            .attr('class', spotID)
            .attr('transform', 'rotate(' + angle + ')')
            .attr('fill', '#FFF');
        }
        this.spotCount++;
        return spotID;
      },
      line: function (angle, color) {
        window.d3.selectAll('.lineLayer').remove();
        this.lineLayer.append('line')
            .attr('transform', 'translate(0,' + parseInt(this.circleOffset) * -1 + ')')
            .attr('x1', 0)
            .attr('y1', 0)
            .attr('x2', Math.cos(this.countPIValue(270 + angle)) * (this.radius - 10))
            .attr('y2', Math.sin(this.countPIValue(270 + angle)) * (this.radius - 10))
            .attr('stroke-width', 2)
            .attr('class', 'lineLayer')
            .attr('stroke', color);
      },
      setBottomInfo: function (header, subHeader) {
        let deviceNameX,
          deviceNameY,
          lotNameX,
          lotNameY,
          infoButtonY,
          textAnchorLot;
        deviceNameX = (parseInt(this.mapWidth / -2) + parseInt(this.bottomInfo.leftMargin));
        deviceNameY = parseInt(this.mapHeight / 2) - 22;
        lotNameX = (parseInt(this.mapWidth / 2) - parseInt(this.moreInfo.rightMargin) - 15);
        lotNameY = parseInt(this.mapHeight / 2) - 22;
        infoButtonY = deviceNameY - 20;
        textAnchorLot = 'end';

        this.svg.append('svg:a')
          .on('click', this.openDetailDialog)
          .attr('patternUnits', 'objectBoundingBox')
          .append('svg:image')
          .attr('class', 'image-icon')
          .attr('xlink:href', informationIcon)
          .attr('width', 24)
          .attr('height', 24)
          .attr('x', (parseInt(this.mapWidth / 2) - parseInt(this.moreInfo.rightMargin)))
          .attr('y', infoButtonY);

        this.svg.append('text')
            .attr('x', deviceNameX)
            .attr('y', deviceNameY)
            .text(header)
            .attr('font-family', 'Arial')
            .attr('font-size', '20px')
            .attr('font-weight', 'bold')
            .attr('fill', '#fff');

        this.svg.append('text')
          .attr('x', lotNameX)
          .attr('y', lotNameY)
          .text(subHeader)
          .attr('text-anchor', textAnchorLot)
          .attr('font-family', 'Arial')
          .attr('font-size', '15px')
          .attr('fill', '#fff');
      },
      openDetailDialog () {
        mixpanel.track('Click info button', {'id': this.deviceId});
        gtag('event', 'click_device_info_button', {event_category: 'click', event_label: 'Click device info button', value: this.deviceId});
        this.dialog = true;
      },
      countPIValue: function (angle) {
        return (angle / 180) * Math.PI;
      },
      getTextPosition: function (position) {
        switch (position) {
          case 'top': {
            return {x: -10, y: -12};
          }
          case 'left': {
            return {x: -30, y: 5};
          }
          case 'right': {
            return {x: 10, y: 10};
          }
          case 'bottom': {
            return {x: -10, y: 20};
          }
          case 'inside': {
            return {x: -7, y: 3};
          }
          default: {
            return {x: -10, y: 5};
          }
        }
      },
      getIcon: function (iconName, iconColor) {
        var iconIndex = 1;
        if (iconColor === '#008000') {
          iconIndex = 2;
        } else if (iconColor === '#ff0000') {
          iconIndex = 3;
        }

        return mapAssets[`${iconName}${iconIndex}`];
      }
    },
    created () {
    }
  };

  var mapAssets = {
    pause1: require('../../../assets/icons/pause1.png'),
    pause2: require('../../../assets/icons/pause2.png'),
    pause3: require('../../../assets/icons/pause3.png'),
    stop1: require('../../../assets/icons/stop1.png'),
    stop2: require('../../../assets/icons/stop2.png'),
    stop3: require('../../../assets/icons/stop3.png'),
    cross1: require('../../../assets/icons/delete1.png'),
    cross2: require('../../../assets/icons/delete2.png'),
    cross3: require('../../../assets/icons/delete3.png'),
    right1: require('../../../assets/icons/right1.png'),
    right2: require('../../../assets/icons/right2.png'),
    right3: require('../../../assets/icons/right3.png'),
    left1: require('../../../assets/icons/left1.png'),
    left2: require('../../../assets/icons/left2.png'),
    left3: require('../../../assets/icons/left3.png')
  };
</script>



// WEBPACK FOOTER //
// DeviceMapPivot.vue?271f6290